import { BrowserRouter, Route, Routes } from 'react-router-dom';
import 'boxicons/css/boxicons.css';
import "./style/bootstrap.css";
import './style/App.css';
import './style/utilities.css';
import WelComePage from './Pages/WelComePage';
import React from 'react';
import Error from './Pages/Error/Error';

function App() {
  return (
    <React.Fragment>
      <BrowserRouter>
        <Routes>
          <Route path='/' element={<WelComePage />} />
          <Route path="*" element={<Error />} />
        </Routes>
      </BrowserRouter>
    </React.Fragment>
  );
}

export default App;
  